/** @type {import('../schema').ProcessDefinition} */
const documentacion = {
  id: "documentacion",
  name: "Documentación del edificio",
  category: "operaciones",
  outcome:
    "Repositorio central de documentos legales/técnicos, consultable por residentes.",
  trigger: "El Administrador sube un documento.",
  actors: ["Administrador", "Sistema", "Residente"],
  status: "COMPLETO",
  description:
    "El admin carga un documento (factura/reglamento/acta/otro) con su tipo, descripción y fecha; el sistema lo almacena con metadatos y, si es público, el residente lo lista y descarga.",
  lanes: [
    { id: "admin", actor: "Administrador" },
    { id: "sys", actor: "Sistema" },
    { id: "res", actor: "Residente" },
  ],
  steps: [
    { id: "s1", laneId: "admin", type: "start", label: "Carga un documento", description: "Tipo (factura/reglamento/acta/otro), archivo, descripción y fecha.", evidence: "src/screens/admin/DocumentacionAdmin.jsx" },
    { id: "s2", laneId: "admin", type: "decision", label: "¿Público o solo admin?" },
    { id: "s3", laneId: "sys", type: "document", label: "Almacena con metadatos", description: "Guarda el archivo y sus metadatos.", evidence: "src/screens/admin/DocumentacionAdmin.jsx" },
    { id: "s4", laneId: "res", type: "task", label: "Lista y descarga el documento", description: "El residente consulta los documentos públicos.", evidence: "src/screens/DocumentacionEdificio.jsx" },
    { id: "s5", laneId: "res", type: "end", label: "Documento consultado" },
    { id: "s6", laneId: "sys", type: "end", label: "Archivo solo visible para el admin" },
  ],
  transitions: [
    { from: "s1", to: "s2" },
    { from: "s2", to: "s3", label: "público" },
    { from: "s2", to: "s6", label: "solo admin" },
    { from: "s3", to: "s4" },
    { from: "s4", to: "s5" },
  ],
};

export default documentacion;
